import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CheckboxComponent, UtcToLocalDateTimePipe } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { EnrollmentFlowType, EnrolmentStatus } from 'src/app/models/class-enrolment.model';
import { GroupEnrolment } from 'src/app/models/course-dto.model';
import { FormatUtil } from 'src/app/utils/format.util';

@Component({
    selector: 'app-class-enrolment-card',
    templateUrl: './class-enrolment-card.component.html',
    styleUrls: ['./class-enrolment-card.component.scss'],
    standalone: false
})
export class ClassEnrolmentCardComponent implements OnInit {
  formatUtil = FormatUtil
  utcDatePipe: UtcToLocalDateTimePipe
  currentLang: string = 'en';
  ENROLLMENT_FLOW_TYPE = EnrollmentFlowType;

  @Input() classEnrollment: GroupEnrolment = { Enrolments: [] };
  @Input() enrolmentStatus: string;
  @Output() pendingSelectionchanges: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('masterCheckBox') masterCheckBox: CheckboxComponent;
  @ViewChildren('childCheckBox') childCheckBoxList: QueryList<CheckboxComponent>;

  constructor(public translateService: TranslateService) { }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang; 
  }

  setChildCheckBox(checked: any): void {
    for (let chk of this.childCheckBoxList) chk.checked = checked;
    let selectedPendingRegistrationIds: any[] = this.classEnrollment.Enrolments.filter(x => x.EnrolmentStatus == EnrolmentStatus.EnrolmentStatusPending || x.EnrolmentStatus == EnrolmentStatus.EnrolmentStatusCanceled).map(x => x.RegistrationId);
    this.pendingSelectionchanges.emit({ checked: checked, selectedPendingRegistrationIds: selectedPendingRegistrationIds });
  }

  setMasterCheckBox(checked: any, registrationId: any): void {
    let masterCheckFlag = this.childCheckBoxList.filter(x => !x.checked).length == 0;
    this.masterCheckBox.checked = masterCheckFlag;
    this.pendingSelectionchanges.emit({ checked: checked, selectedPendingRegistrationIds: [registrationId] });
  }

}
